import React, { MouseEvent, useEffect, useState } from "react"

import { scheduleApi } from "@shared/apis"
import {
  Schedule,
  useAccount,
  useLayerPopupContext,
  useSchedule,
} from "@shared/contexts"
import { kick, redirect, removeUsername } from "@shared/modules"

function LiveEnd() {
  const { account } = useAccount()

  const { close } = useLayerPopupContext()
  const { schedule } = useSchedule()
  const [recommends, setRecommends] = useState<Schedule[]>()

  const isAnonymous = account?.viewer?.role === "ANONYMOUS"
  const isScheduleEnd = schedule?.scheduleStatus === "END"

  useEffect(() => {
    scheduleApi.getRecommends().then(({ data }) => {
      const { content: recommends } = data
      setRecommends(recommends)
    })
  }, [])

  return (
    <React.Fragment>
      <article
        className="popup"
        style={{ width: "540px", margin: "-155px 0 0 -270px" }}
      >
        <div className="titB">
          <h1>방송종료</h1>
          <a
            href="#!"
            onClick={(e: MouseEvent) => {
              e.preventDefault()

              if (schedule && isScheduleEnd) {
                kick()
                return
              }

              close()
            }}
            title="닫기"
          >
            닫기
          </a>
        </div>
        <div className="txtB">
          <div className="roundB txt">
            <p>내 투자의 성공 파트너, 와우넷에서 만나보세요.</p>
          </div>
          <ul className="expertB">
            {recommends &&
              recommends.map((recommend) => {
                return (
                  <li key={recommend.id}>
                    <a
                      href="#!"
                      onClick={(e: MouseEvent) => {
                        e.preventDefault()

                        if (isAnonymous) {
                          removeUsername()
                        }

                        redirect(`/${recommend.user.username}/${recommend.id}`)
                      }}
                    >
                      <div className="poR">
                        <i>{recommend.streamingStatus}</i>
                        <img
                          src={recommend.user.profileImageUrl}
                          alt="전문가"
                        />
                      </div>
                      <p>
                        [{recommend.user.nickname}] {recommend.title}
                      </p>
                    </a>
                  </li>
                )
              })}
          </ul>
        </div>
        <div className="btnB">
          <a
            href="#!"
            onClick={(e: MouseEvent) => {
              e.preventDefault()
              kick()
            }}
            className="btn"
            title="방송종료"
          >
            방송종료
          </a>
        </div>
      </article>
    </React.Fragment>
  )
}

export default LiveEnd
